
<div
  class="cmp-category-item ws-typography"
  :class="{ 'highlighted': isSelected, 'q-my-md': mobile }"
>
  <div class="column items-center text-center">
    <div class="q-mb-lg">
      <img
        :src="logoSrc"
        :alt="itemTitle"
        class="item-logo"
        width="45px"
        height="45px"
      />
    </div>
    <div
      class="title-section"
      :class="[desktop ? 'q-mb-lg' : 'q-mb-md']"
    >
      <h5 class="subtle">
        {{ $t('modules.i_want_product.' + item.name + '.subtitle') }}
      </h5>
      <h5 class="title">
        {{ $t('modules.i_want_product.' + item.name + '.title') }}
      </h5>
    </div>
    <div :class="[desktop ? 'q-mb-lg' : 'q-mb-md']">
      <!-- eslint-disable vue/no-v-html -->
      <span
        class="subtitle"
        v-html="xss(
          $t('modules.i_want_product.website.period_from', {price: $n(item.prices.marketingPrice, 'currency')})
        )"
      >
      </span>
      <!--eslint-enable-->
    </div>
    <div :class="[desktop ? 'q-mb-3xl' : 'q-mb-xl']">
      <span class="note">
        {{ $t('modules.i_want_product.' + item.name + '.description') }}
      </span>
    </div>
    <div class="full-width">
      <ws-button
        primary
        :icon="isSelected ? 'close' : undefined"
        icon-right
        class="select-product full-width"
        :label="selectedBtnLabel"
        @click="updateSelected()"
      />
    </div>
    <div v-if="isRecommended" class="recommended q-py-sm q-px-sm text-bold">
      <span>
        {{ $t('modules.i_want_product.website.recommended') }}
      </span>
    </div>
  </div>
</div>
